// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import IeCircleFilledSvg from "@fishx/icons-svg/es/asn/IeCircleFilled";
import FishxIcon from '../components/FishxIcon';

var IeCircleFilled = function IeCircleFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: IeCircleFilledSvg
  }));
};

IeCircleFilled.displayName = 'IeCircleFilled';
export default React.forwardRef(IeCircleFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/IeCircleFilled.js
// module id = 2953
// module chunks = 0